var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "1em",
      "height": "1em",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "aria-hidden": "true"
    }
  }, [_c('path', {
    attrs: {
      "d": "M20 11A8.1 8.1 0 0 0 4.5 9M4 5v4h4"
    }
  }), _c('path', {
    attrs: {
      "d": "M4 13a8.1 8.1 0 0 0 15.5 2M20 19v-4h-4"
    }
  })]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };